import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/search_icon.svg'
import _imports_1 from '@/assets/images/close_icon_grey.svg'


const _hoisted_1 = { class: "search-bar-container" }
const _hoisted_2 = {
  key: 0,
  class: "glass-img-div"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "search-image",
  src: _imports_0
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "close-img-div"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_field = _resolveComponent("input-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.showCloseIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.showCloseIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("img", {
            class: "search-image close-icon",
            src: _imports_1,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearSearchText && _ctx.clearSearchText(...args)))
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_input_field, {
      class: "search-bar",
      placeholder: 'Search',
      autocomplete: 'off',
      type: 'text',
      value: _ctx.searchItem,
      onInput: _ctx.search
    }, null, 8, ["value", "onInput"])
  ]))
}